import {TemplateResult, html} from "lit";

export abstract class Step {
  renderStep(): TemplateResult {
    return html`
      <div slot="title" class="ents-or-title">
        ${this.renderTitle()}
      </div>
      <div class="ents-or-content">
        ${this.renderContent()}
      </div>
      <div slot="footer" class="ents-or-footer">
        ${this.renderFooter()}
      </div>
    `;
  }

  protected abstract renderTitle(): TemplateResult;

  protected abstract renderContent(): TemplateResult;

  protected abstract renderFooter(): TemplateResult;
}
